import { render, staticRenderFns } from "./superAdminSocietyMemberList.vue?vue&type=template&id=2fb32025&scoped=true&"
import script from "./superAdminSocietyMemberList.vue?vue&type=script&lang=js&"
export * from "./superAdminSocietyMemberList.vue?vue&type=script&lang=js&"
import style0 from "./superAdminSocietyMemberList.vue?vue&type=style&index=0&id=2fb32025&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb32025",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VCol,VContainer,VPagination,VRow,VSimpleTable})
